module.exports = __webpack_public_path__ + "img/prize-01.95fa8ed4.png";